<div>
    <header class="sticky-header">
        <app-header [showHeaderButtons]="!isLoginPage && !isInitializing"></app-header>
    </header>
    <main>
        <router-outlet></router-outlet>
    </main>
    <footer>
        <app-footer></app-footer>
    </footer>
</div>